import { render } from "./PurchaseItem.vue?vue&type=template&id=281f6a46&scoped=true"
import script from "./PurchaseItem.vue?vue&type=script&lang=js"
export * from "./PurchaseItem.vue?vue&type=script&lang=js"

import "./PurchaseItem.vue?vue&type=style&index=0&id=281f6a46&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281f6a46"],['__file',"src/views/MyAccount/MyRedemption/components/PurchaseItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "281f6a46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('281f6a46', __exports__)) {
    console.log('reload')
    api.reload('281f6a46', __exports__)
  }
  
  module.hot.accept("./PurchaseItem.vue?vue&type=template&id=281f6a46&scoped=true", () => {
    console.log('re-render')
    api.rerender('281f6a46', render)
  })

}


export default __exports__